import { useTranslation } from "react-i18next";

import { Icon } from "@/shared/ui";

/**
 * Figma: `NetworkRow` (17:64), варианты TRC20 (с пометкой «рекомендуем») и
 * ERC20. Вариант BEP20 не реализуется (DESIGN.md §3).
 *
 * Список сетей приходит с бэкенда и захардкожен быть не может, поэтому
 * «рекомендуем» вешается на TRC20 по имени — это ярлык интерфейса, а не
 * данные: комиссия в TRC20 действительно ниже.
 */
const RECOMMENDED = "TRC20";

interface NetworkRowProps {
  network: string;
  selected: boolean;
  onSelect: () => void;
}

export function NetworkRow({ network, selected, onSelect }: NetworkRowProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-pressed={selected}
      data-haptic="select"
      onClick={onSelect}
      className={[
        "press-row flex w-full items-center justify-between rounded-2xl border p-4 text-left",
        "transition-colors duration-[var(--motion-fast)] ease-standard",
        selected
          ? "border-action-primary bg-surface-selected"
          : "border-border-subtle bg-background-elevated",
      ].join(" ")}
    >
      <span className="flex flex-col gap-0.5">
        <span className="text-body font-semibold text-text-primary">{network}</span>
        {network === RECOMMENDED ? (
          <span className="text-caption font-medium text-status-profit">
            {t("wallet.networkRecommended")}
          </span>
        ) : null}
      </span>
      <Icon name="caretRight" size={14} className="text-text-tertiary" />
    </button>
  );
}
